import { NakliyeFaturaListesiPage } from './../pages/nakliye-fatura-listesi/nakliye-fatura-listesi';
import { NakliyeFaturaGirisPage } from './../pages/nakliye-fatura-giris/nakliye-fatura-giris';
import { Ortak } from './ortak';
import { SubelerPage } from './../pages/Yonetim/subeler/subeler';
import { ServisKayitArsivPage } from './../pages/ServisKayit/servis-kayit-arsiv/servis-kayit-arsiv';
import { BekleyenListesiPage } from './../pages/ServisKayit/bekleyen-listesi/bekleyen-listesi';
import { TeknikServisAnaSayfaPage } from './../pages/ServisKayit/teknik-servis-ana-sayfa/teknik-servis-ana-sayfa';
import { IsListesiPage } from './../pages/ServisKayit/is-listesi/is-listesi';
import { PerakendeSatisFaturalariPage } from './../pages/faturaislemleri/perakende-satis-faturalari/perakende-satis-faturalari';
import { StokDegerRaporPage } from './../pages/Raporlars/stok-deger-rapor/stok-deger-rapor';
import { UrunSatisRaporuPage } from './../pages/Raporlars/urun-satis-raporu/urun-satis-raporu';
import { KdvSatisRaporuPage } from './../pages/Raporlars/kdv-satis-raporu/kdv-satis-raporu';
import { KategoriBazliRaporPage } from './../pages/Raporlars/kategori-bazli-rapor/kategori-bazli-rapor';
import { MarkaBazliRaporPage } from './../pages/Raporlars/marka-bazli-rapor/marka-bazli-rapor';
import { KasaHareketleriRaporPage } from './../pages/Raporlars/kasa-hareketleri-rapor/kasa-hareketleri-rapor';
import { CekSenetListePage } from './../pages/CekSenetIslemleri/cek-senet-liste/cek-senet-liste';
import { CekSenetAnaSayfaPage } from './../pages/CekSenetIslemleri/cek-senet-ana-sayfa/cek-senet-ana-sayfa';
import { ParametreAyarlariPage } from './../pages/Yonetim/parametre-ayarlari/parametre-ayarlari';
import { PerakendeSatisPage } from './../pages/PerakendeIslemleri/perakende-satis/perakende-satis';
import { AlacakliHesaplarReportPage } from './../pages/Raporlars/alacakli-hesaplar-report/alacakli-hesaplar-report';
import { BorcluHesaplarReportPage } from './../pages/Raporlars/borclu-hesaplar-report/borclu-hesaplar-report';
import { ProgramAyarlariPage } from './../pages/Yonetim/program-ayarlari/program-ayarlari';
import { SatisFaturaListesiPage } from './../pages/faturaislemleri/satis-fatura-listesi/satis-fatura-listesi';
import { AlisFaturaListesiPage } from './../pages/faturaislemleri/alis-fatura-listesi/alis-fatura-listesi';
import { SatisfaturasiolusturPage } from './../pages/faturaislemleri/satisfaturasiolustur/satisfaturasiolustur';
import { FaturaAnaSayfaPage } from './../pages/faturaislemleri/fatura-ana-sayfa/fatura-ana-sayfa';
import { AlisFaturalariPage } from './../pages/faturaislemleri/alis-faturalari/alis-faturalari';
import { KasiyerBazliRaporPage } from './../pages/Raporlars/kasiyer-bazli-rapor/kasiyer-bazli-rapor';
import { MarkaListesiPage } from './../pages/Yonetim/MarkaIslemleri/marka-listesi/marka-listesi';
import { KategoriListePage } from './../pages/Yonetim/KategoriIslemleri/kategori-liste/kategori-liste';
import { BirimListePage } from './../pages/Yonetim/BirimIslemleri/birim-liste/birim-liste';
import { GelirgiderPage } from './../pages/Yonetim/gelirgider/gelirgider';
import { KasalistePage } from './../pages/Yonetim/KasaIslemleri/kasaliste/kasaliste';
import { KullaniciListePage } from './../pages/Yonetim/kullanici-liste/kullanici-liste';
import { GirisPage } from './../pages/giris/giris';
import { CarilerPage } from './../pages/CariIslemleri/cariler/cariler';
import { YonetimAnaSayfaPage } from './../pages/Yonetim/yonetim-ana-sayfa/yonetim-ana-sayfa';
import { HomePage } from './../pages/home/home';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { StoklarPage } from '../pages/StokIslemleri/stoklar/stoklar';
import { ReportsPage } from '../pages/Raporlars/reports/reports';
import { RaporAnaSayfaPage } from '../pages/Raporlars/rapor-ana-sayfa/rapor-ana-sayfa';
import { GrupListesiPage } from '../pages/Yonetim/CariGrupIslemleri/grup-listesi/grup-listesi';
import { BankListePage } from '../pages/BankaIslemleri/bank-liste/bank-liste';
import { GunlukCariRaporPage } from '../pages/gunluk-cari-rapor/gunluk-cari-rapor';

@Injectable()
export class PagesProvider {
 
  components = {
    "AnasayfaPage": HomePage,
    "Yonetim": YonetimAnaSayfaPage,

  }
  constructor() {
   
  }

  menuler() {
    return new Promise((res, err) => {
      var menu = {
        LEFT_MENU: [],
        MAIN_MENU: [],
        TEKNIK_MENU:[],
        KULLANICI_MENU: [],
        YONETIM_MENU: [], RAPOR_MENU: [], FATURA_MENU: [], YONETICI_LEFT_MENU: [], KULLANICI_LEFT_MENU: [], CEKSENET_MENU: []
      };
      menu.LEFT_MENU = this.defaultLeftMenu;
      menu.MAIN_MENU = this.defaultMainMenu;
      menu.KULLANICI_MENU = this.KullaniciMainMenu;
      menu.YONETIM_MENU = this.YonetimMainMenu;
      menu.RAPOR_MENU = this.RaporlarMainMenu;
      menu.FATURA_MENU = this.FaturaMenusu;
      menu.YONETICI_LEFT_MENU = this.YoneticiLeftMenu;
      menu.KULLANICI_LEFT_MENU = this.KullaniciLeftMenu;
      menu.CEKSENET_MENU = this.CekSenetMenusu;
      menu.TEKNIK_MENU=this.TeknikServisMenu;
      res(menu);
    })
  }
  defaultLeftMenu = [
    {
      PARENT_SAYFA: { PAGE_NAME: "Yönetim" }, ALT_SAYFALAR: [
        { PAGE_NAME: "Menü", PAGE_ION_ICON: "home", PAGE_COMPONENT: HomePage },
        { PAGE_NAME: "Müşteriler", PAGE_COMPONENT: CarilerPage },
        { PAGE_NAME: "ÇIKIŞ", PAGE_COMPONENT: GirisPage },
      ]
    },
    {
      PARENT_SAYFA: { PAGE_NAME: "Belge İşlemleri" }, ALT_SAYFALAR: [
      ]
    },
    {
      PARENT_SAYFA: { PAGE_NAME: "Raporlama" }, ALT_SAYFALAR: [
        { PAGE_NAME: "Raporlar", PAGE_ION_ICON: "pie", PAGE_COMPONENT: ReportsPage }
      ]
    },
    {
      PARENT_SAYFA: { PAGE_NAME: "Diğer İşlemler" }, ALT_SAYFALAR: [
        { PAGE_NAME: "Ayarlar", PAGE_ION_ICON: "settings", PAGE_COMPONENT: YonetimAnaSayfaPage },
      ]
    },
  ]; cihazid = "";

  defaultMainMenu = [
   
    //  { PAGE_NAME: "Teknik Servis", PAGE_ICON: "fa fa-wrench fa-3x", PAGE_COMPONENT: TeknikServisAnaSayfaPage, TYPE: "NAV", },
    { PAGE_NAME: "Müşteriler",  PAGE_ICON: "fa fa fa-users fa-3x", PAGE_COMPONENT: CarilerPage, TYPE: "NAV", },
    { PAGE_NAME: "Malzemeler", PAGE_ICON: "fa fa-cubes fa-3x", PAGE_COMPONENT: StoklarPage, TYPE: "NAV", },
 
    { PAGE_NAME: "Perakende Satış", PAGE_ICON: "fa fa-cart-plus fa-3x", PAGE_COMPONENT: PerakendeSatisPage, TYPE: "NAV", },
    { PAGE_NAME: "Faturalar ", PAGE_ICON: "fa fa-pencil-square-o fa-3x", PAGE_COMPONENT: FaturaAnaSayfaPage, TYPE: "NAV", },
     { PAGE_NAME: "Çek-Senet-Banka ", PAGE_ICON: "fa fa-file-text-o fa-3x", PAGE_COMPONENT: CekSenetAnaSayfaPage, TYPE: "NAV", },
    //  { PAGE_NAME: "Banka İşlemleri ", PAGE_ICON: "fa fa-university fa-3x", PAGE_COMPONENT: BankListePage, TYPE: "NAV", },
    { PAGE_NAME: "Raporlar", PAGE_ICON: "fa fa-pie-chart fa-3x", PAGE_COMPONENT: RaporAnaSayfaPage, TYPE: "NAV", },
    { PAGE_NAME: "Yönetim", PAGE_ICON: "fa fa-cogs fa-3x", PAGE_COMPONENT: YonetimAnaSayfaPage, TYPE: "NAV", },


  ];
  RaporlarMainMenu = [
    { PAGE_NAME: "Gün Sonu Raporu", PAGE_ICON: "fa fa-pie-chart fa-3x", PAGE_COMPONENT: ReportsPage, TYPE: "NAV", },
     { PAGE_NAME: "Günlük Hareketler Raporu", PAGE_ICON: "fa fa-pie-chart fa-3x", PAGE_COMPONENT: GunlukCariRaporPage, TYPE: "NAV", },
    { PAGE_NAME: "Ürün Satış Raporu", PAGE_ICON: "fa fa-barcode fa-3x", PAGE_COMPONENT: UrunSatisRaporuPage, TYPE: "NAV", },
    { PAGE_NAME: "Borçlu Cari Hesaplar", PAGE_ICON: "fa fa-briefcase fa-3x", PAGE_COMPONENT: BorcluHesaplarReportPage, TYPE: "NAV", },
    { PAGE_NAME: "Alacaklı Cari Hesaplar", PAGE_ICON: "fa fa-briefcase fa-3x", PAGE_COMPONENT: AlacakliHesaplarReportPage, TYPE: "NAV", },
    { PAGE_NAME: "Kasa Hareketleri", PAGE_ICON: "fa fa-exchange fa-3x", PAGE_COMPONENT: KasaHareketleriRaporPage, TYPE: "NAV", },
    { PAGE_NAME: "Stok Değer Raporu", PAGE_ICON: "fa fa-bar-chart fa-3x", PAGE_COMPONENT: StokDegerRaporPage, TYPE: "NAV", },
    { PAGE_NAME: "Kategori Bazlı Rapor", PAGE_ICON: "fa fa-bar-chart fa-3x", PAGE_COMPONENT: KategoriBazliRaporPage, TYPE: "NAV", },
    { PAGE_NAME: "Marka Bazlı Rapor", PAGE_ICON: "fa fa-tags fa-3x", PAGE_COMPONENT: MarkaBazliRaporPage, TYPE: "NAV", },
    { PAGE_NAME: "Kasiyer Bazlı Rapor", PAGE_ICON: "fa fa-users fa-3x", PAGE_COMPONENT: KasiyerBazliRaporPage, TYPE: "NAV", },
    { PAGE_NAME: "Kdv Grub Raporu", PAGE_ICON: "fa fa-percent fa-3x", PAGE_COMPONENT: KdvSatisRaporuPage, TYPE: "NAV", },

  ];

  FaturaMenusu = [
    { PAGE_NAME: "Perakende Satış Faturaları", PAGE_ICON: "fa fa-file-text fa-3x", PAGE_COMPONENT: PerakendeSatisFaturalariPage, TYPE: "NAV", },
    { PAGE_NAME: "Satış Faturaları", PAGE_ICON: "fa fa-file-text fa-3x", PAGE_COMPONENT: SatisFaturaListesiPage, TYPE: "NAV", },
    { PAGE_NAME: "Alış Faturaları", PAGE_ICON: "fa fa-file-text-o fa-3x", PAGE_COMPONENT: AlisFaturaListesiPage, TYPE: "NAV", },
    { PAGE_NAME: "Satış Faturası Oluştur", PAGE_ICON: "fa fa-pencil-square-o fa-3x", PAGE_COMPONENT: SatisfaturasiolusturPage, TYPE: "NAV", },
    { PAGE_NAME: "Alış Faturası Oluştur", PAGE_ICON: "fa fa-pencil-square-o fa-3x", PAGE_COMPONENT: AlisFaturalariPage, TYPE: "NAV", },
     { PAGE_NAME: "Nakliye Faturaları", PAGE_ICON: "fa fa-truck fa-3x", PAGE_COMPONENT: NakliyeFaturaListesiPage, TYPE: "NAV", },
 

  ];
  CekSenetMenusu = [
    { PAGE_NAME: "Banka İşlemleri ", PAGE_ICON: "fa fa-university fa-3x", PAGE_COMPONENT: BankListePage, TYPE: "NAV", },
    { PAGE_NAME: "Müşteri Çekleri", PAGE_ICON: "fa fa-file-text fa-3x", PAGE_COMPONENT: CekSenetListePage, TYPE: "NAV", PARAM: "Müşteri Çeki" },
    { PAGE_NAME: "Müşteri Senetleri", PAGE_ICON: "fa fa-file-text-o fa-3x", PAGE_COMPONENT: CekSenetListePage, TYPE: "NAV", PARAM: "Müşteri Seneti" },
    { PAGE_NAME: "Verilen Çekler", PAGE_ICON: "fa fa-pencil-square-o fa-3x", PAGE_COMPONENT: CekSenetListePage, TYPE: "NAV", PARAM: "Verilen Çekler" },
    { PAGE_NAME: "Verilen Senetler", PAGE_ICON: "fa fa-pencil-square-o fa-3x", PAGE_COMPONENT: CekSenetListePage, TYPE: "NAV", PARAM: "Verilen Senetler" },
    { PAGE_NAME: "Vadesi Yaklaşan Çekler", PAGE_ICON: "fa fa-calendar-o fa-3x", PAGE_COMPONENT: CekSenetListePage, TYPE: "NAV", PARAM: "Vadesi Yaklaşan Çekler" },
    { PAGE_NAME: "Vadesi Geçen Çekler", PAGE_ICON: "fa fa-calendar fa-3x", PAGE_COMPONENT: CekSenetListePage, TYPE: "NAV", PARAM: "Vadesi Geçen Çekler" },
    { PAGE_NAME: "Vadesi Yaklaşan Senetler", PAGE_ICON: "fa fa-calendar-o fa-3x", PAGE_COMPONENT: CekSenetListePage, TYPE: "NAV", PARAM: "Vadesi Yaklaşan Senetler" },
    { PAGE_NAME: "Vadesi Geçen Senetler", PAGE_ICON: "fa fa-calendar fa-3x", PAGE_COMPONENT: CekSenetListePage, TYPE: "NAV", PARAM: "Vadesi Geçen Senetler" },


  ];
  KullaniciMainMenu = [
    // { PAGE_NAME: "Müşteriler", PAGE_ICON: "fa fa fa-users fa-3x", PAGE_COMPONENT: CarilerPage, TYPE: "NAV", },
    //{ PAGE_NAME: "Malzemeler", PAGE_ICON: "fa fa-cubes fa-3x", PAGE_COMPONENT: StoklarPage, TYPE: "NAV", },
    //{ PAGE_NAME: "Faturalar", PAGE_ICON: "fa fa-cubes fa-3x", PAGE_COMPONENT: PerakendeSatisFaturalariPage, TYPE: "NAV", },
    { PAGE_NAME: "Perakende Satış", PAGE_ICON: "fa fa-cart-plus fa-3x", PAGE_COMPONENT: PerakendeSatisPage, TYPE: "NAV", },

  ];
  
  YonetimMainMenu = [
    { PAGE_NAME: "Birimler", PAGE_ICON: "fa fa-cubes fa-3x", PAGE_COMPONENT: BirimListePage, TYPE: "NAV", },
    { PAGE_NAME: "Kategoriler", PAGE_ICON: "fa fa-filter fa-3x", PAGE_COMPONENT: KategoriListePage, TYPE: "NAV", },
    { PAGE_NAME: "Markalar", PAGE_ICON: "fa fa-thumb-tack fa-3x", PAGE_COMPONENT: MarkaListesiPage, TYPE: "NAV", },
    { PAGE_NAME: "Kasalar", PAGE_ICON: "fa fa-briefcase fa-3x", PAGE_COMPONENT: KasalistePage, TYPE: "NAV", },
    { PAGE_NAME: "Kullanıcılar", PAGE_ICON: "fa fa-user fa-3x", PAGE_COMPONENT: KullaniciListePage, TYPE: "NAV", },
    { PAGE_NAME: "Gelir-Gider", PAGE_ICON: "fa fa-arrows-h fa-3x", PAGE_COMPONENT: GelirgiderPage, TYPE: "NAV", },
    { PAGE_NAME: "Cari Grupları", PAGE_ICON: "fa fa-users fa-3x", PAGE_COMPONENT: GrupListesiPage, TYPE: "NAV", },
    //  { PAGE_NAME: "Data Sync", PAGE_ICON: "fa fa-refresh fa-3x", PAGE_COMPONENT: DataSyncPage, TYPE: "NAV", },
    { PAGE_NAME: "Yerel Ayarlar", PAGE_ICON: "fa fa-cogs fa-3x", PAGE_COMPONENT: ProgramAyarlariPage, TYPE: "NAV", },
    { PAGE_NAME: "Program Ayarları", PAGE_ICON: "fa fa-cogs fa-3x", PAGE_COMPONENT: ParametreAyarlariPage, TYPE: "NAV", },
    { PAGE_NAME: "Şubeler", PAGE_ICON: "fa fa-university fa-3x", PAGE_COMPONENT: SubelerPage, TYPE: "NAV", },

  ];
  YoneticiLeftMenu = [

    { PAGE_NAME: "Müşteriler", PAGE_ICON: "fa fa fa-users fa-3x", PAGE_COMPONENT: CarilerPage, TYPE: "NAV", },
    { PAGE_NAME: "Malzemeler", PAGE_ICON: "fa fa-cubes fa-3x", PAGE_COMPONENT: StoklarPage, TYPE: "NAV", },
    { PAGE_NAME: "Faturalar ", PAGE_ICON: "fa fa-pencil-square-o fa-3x", PAGE_COMPONENT: FaturaAnaSayfaPage, TYPE: "NAV", },
    { PAGE_NAME: "Raporlar", PAGE_ICON: "fa fa-pie-chart fa-3x", PAGE_COMPONENT: RaporAnaSayfaPage, TYPE: "NAV", },
    { PAGE_NAME: "Yönetim", PAGE_ICON: "fa fa-cogs fa-3x", PAGE_COMPONENT: YonetimAnaSayfaPage, TYPE: "NAV", },

  ];
  KullaniciLeftMenu = [
    { PAGE_NAME: "Müşteriler", PAGE_ICON: "fa fa fa-users fa-3x", PAGE_COMPONENT: CarilerPage, TYPE: "NAV", },
    { PAGE_NAME: "Malzemeler", PAGE_ICON: "fa fa-cubes fa-3x", PAGE_COMPONENT: StoklarPage, TYPE: "NAV", },
    { PAGE_NAME: "Perakende Satış", PAGE_ICON: "fa fa-cart-plus fa-3x", PAGE_COMPONENT: PerakendeSatisPage, TYPE: "NAV", },
    { PAGE_NAME: "Faturalar ", PAGE_ICON: "fa fa-pencil-square-o fa-3x", PAGE_COMPONENT: FaturaAnaSayfaPage, TYPE: "NAV", },

  ];
  TeknikServisMenu=[

    { PAGE_NAME: "Servis Kayıtları", PAGE_ICON: "fa fa fa-wrench fa-3x", PAGE_COMPONENT: IsListesiPage, TYPE: "NAV", },
    { PAGE_NAME: "Bekleyen Servisler", PAGE_ICON: "fa fa-cogs fa-3x", PAGE_COMPONENT: BekleyenListesiPage, TYPE: "NAV", },
    { PAGE_NAME: "Tamamlanan Servisler", PAGE_ICON: "fa fa-check-square-o fa-3x", PAGE_COMPONENT: ServisKayitArsivPage, TYPE: "NAV", },
   

  ]



}



// WEBPACK FOOTER //
// ./src/providers/pages-provider.ts